module.exports = __webpack_public_path__ + "img/search-icon.b1661f9b.svg";